import React from 'react';
import { Badge } from '../core/Badge.jsx';
import { IconButton } from '../core/IconButton.jsx';

const STATUS = {
  paid:    { badge: 'paid', label: 'Cobrado', amountColor: 'var(--brand-green)' },
  pending: { badge: 'pending', label: 'Pendiente', amountColor: 'var(--text-strong)' },
  overdue: { badge: 'overdue', label: 'Vencido', amountColor: 'var(--text-strong)' },
};

/**
 * TransactionRow — the app's signature invoice card: client + plan, amount +
 * status pill, a due-date footer and a row of tinted actions.
 */
export function TransactionRow({
  name,
  plan,
  amount,
  status = 'pending',
  dueLabel = 'Vencimiento',
  dueDate,
  overdueNote,
  actions,
  style = {},
  ...rest
}) {
  const st = STATUS[status] || STATUS.pending;
  const acts = actions || [
    { icon: 'banknote', tone: 'green', label: 'Registrar pago' },
    { icon: 'bell', tone: 'blue', label: 'Enviar recordatorio' },
    { icon: 'link', tone: 'neutral', label: 'Copiar link' },
  ];

  return (
    <div
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--pad-card)',
        fontFamily: 'var(--font-sans)',
        boxShadow: 'var(--shadow-card)',
        ...style,
      }}
      {...rest}
    >
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16 }}>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 'var(--fs-h2)', fontWeight: 'var(--fw-bold)', color: 'var(--text-strong)', lineHeight: 1.15 }}>
            {name}
          </div>
          {plan && (
            <div style={{ fontSize: 'var(--fs-sm)', color: 'var(--text-faint)', marginTop: 4 }}>{plan}</div>
          )}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8 }}>
          <div style={{ fontSize: 'var(--fs-money)', fontWeight: 'var(--fw-extrabold)', letterSpacing: 'var(--ls-tight)', color: st.amountColor, lineHeight: 1, whiteSpace: 'nowrap' }}>
            {amount}
          </div>
          <Badge tone={st.badge}>{st.label}</Badge>
        </div>
      </div>

      {/* Footer */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, marginTop: 18, paddingTop: 16, borderTop: '1px solid var(--border)' }}>
        <div>
          {overdueNote ? (
            <div style={{ fontSize: 'var(--fs-xs)', fontWeight: 'var(--fw-extrabold)', fontStyle: 'italic', color: 'var(--status-overdue)', textTransform: 'uppercase', letterSpacing: 'var(--ls-overline)' }}>
              {overdueNote}
            </div>
          ) : (
            <div style={{ fontSize: 'var(--fs-overline)', fontWeight: 'var(--fw-bold)', color: 'var(--text-hint)', textTransform: 'uppercase', letterSpacing: 'var(--ls-overline)' }}>
              {dueLabel}
            </div>
          )}
          {dueDate && (
            <div style={{ fontSize: 'var(--fs-sm)', fontWeight: 'var(--fw-semibold)', color: 'var(--text-muted)', marginTop: 3 }}>{dueDate}</div>
          )}
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          {acts.map((a, i) => (
            <IconButton key={i} icon={a.icon} tone={a.tone} active={a.active} label={a.label} size="lg" />
          ))}
        </div>
      </div>
    </div>
  );
}
